import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/Auth";

const PrivateRoute = ({ children }) => {
  const { currentUser } = useContext(AuthContext);
  console.log(currentUser,"PrivateRoute")

  return currentUser ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
